import React, {FC, HTMLAttributes} from 'react';
import css from './CheckSubscription.module.scss';
import checkCircle from "../../../../assets/unsubscribe/icons/check_circle.svg";
import Button from "../../../../elements/Button/Button";
import classNames from 'classnames/bind';

const cx = classNames.bind(css);

interface CheckSubscriptionProps extends HTMLAttributes<HTMLDivElement> {
    title: string,
    btnName: string,
    subTitle?: string | null,
    link?: string,
}

const CheckSubscription: FC<CheckSubscriptionProps> = ({btnName, title, subTitle, link, className}) => {
    return (
        <section className={cx(css.main, className)}>
            <img className={css.main__logo} src={checkCircle} alt="done"/>
            <h2 className={css.main__title}> {title} </h2>
            {subTitle && <p className={css.main__subTitle}> {subTitle} </p>}
            <Button href={link || ''}>{btnName}</Button>
        </section>
    );
};

export default CheckSubscription;